var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canGoBack),expression:"canGoBack"}],staticClass:"topbar"},[_c('a',{on:{"click":_vm.goback}},[_vm._v("返回上一页(Back)")])])}
var staticRenderFns = []

export { render, staticRenderFns }